<script lang="ts" setup>
import UserNameRow from '@/components/UserNameRow.vue'

/**
 * Shared "Username" / "Email" row followed by the first/last name row, used in the CreateTeacher and StudentsView forms.
 */
defineProps<{
  emailAttrs?: Record<string, unknown>
  errors: { email?: string; firstName?: string; lastName?: string; username?: string }
  firstNameAttrs?: Record<string, unknown>
  lastNameAttrs?: Record<string, unknown>
  usernameAttrs?: Record<string, unknown>
  usernameDisabled?: boolean
}>()

const username = defineModel<string | undefined>('username', { required: true })
const email = defineModel<string | undefined>('email', { required: true })
const firstName = defineModel<string | undefined>('firstName', { required: true })
const lastName = defineModel<string | undefined>('lastName', { required: true })
</script>

<template>
  <v-row>
    <v-col md="3">
      <v-text-field
        v-model="username"
        v-bind="usernameAttrs"
        :disabled="usernameDisabled"
        :error-messages="errors.username"
        label="Username"
        variant="underlined"
      />
    </v-col>
    <v-col md="3">
      <v-text-field v-model="email" v-bind="emailAttrs" :error-messages="errors.email" label="Email" variant="underlined" />
    </v-col>
  </v-row>
  <user-name-row
    v-model:first-name="firstName"
    v-model:last-name="lastName"
    :errors="errors"
    :first-name-attrs="firstNameAttrs"
    :last-name-attrs="lastNameAttrs"
  />
</template>
